import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface WindowSizeInterface {
  isMobile: boolean;
  windowWidth: number;
  windowHeight: number;
}

interface WindowSizeAction {
  setIsMobile: (isMobile: boolean) => void;
  setWindowSize: (width: number, height: number) => void;
  initializeWindowSize: () => void;
}

const useWindowSize = create<WindowSizeInterface & WindowSizeAction>()(
  devtools(
    immer((set) => ({
      isMobile: window.innerWidth < 768,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      setIsMobile: (isMobile: boolean) => {
        set((state) => {
          state.isMobile = isMobile;
        });
      },
      setWindowSize: (width: number, height: number) => {
        set((state) => {
          state.windowWidth = width;
          state.windowHeight = height;
          state.isMobile = width < 768;
        });
      },
      initializeWindowSize: () => {
        set((state) => {
          state.windowWidth = window.innerWidth;
          state.windowHeight = window.innerHeight;
          state.isMobile = window.innerWidth < 768;
        });
      },
    })),
    {
      name: 'windowSizeStore',
    },
  ),
);

export default useWindowSize;
